module.exports = __webpack_public_path__ + "static/crema-df14b34b65b0f7e55fcc91c3c56caabf.png";